module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('h2', {
    staticClass: "Verse-head",
    attrs: {
      "id": "_idParaDest-5"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor005"
    }
  }), _vm._v("You/Angel")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-new"
  }, [_vm._v("So you were the angel")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("who held me when I cried")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-new"
  }, [_vm._v("Nursed my grieving passion ")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("with your open-bodied grace")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-new"
  }, [_vm._v("Tears became the well-spring")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("to salve my wounded life")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-new"
  }, [_vm._v("Yours the balm that healed me")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("held me ’til I came back live")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-new"
  }, [_vm._v("Mourning turned to dancing ")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("my child farewelled in peace")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-new"
  }, [_vm._v("Your love will never leave me")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("so long my beating heart.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ff441b8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781398400801_EPUB-7.vue
// module id = 78
// module chunks = 0